<template>
  <div class="modal-window large split active">
    <overlay-scrollbars :options="{ className: 'custom-scrollbar os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
      <div class="grid-x split">
        <div class="cell flex-column" style="height: 600px;">
          <div class="modal-window-body no-padding">
            <div class="iframe-container pdf">
              <iframe v-if="pdfSource" id="pdfFrame" name="pdfFrame" frameborder="0" marginwidth="0" marginheight="0" scrolling="no" :src="pdfSource + '#view=FitH&toolbar=1'"></iframe>
              <TheEmptyList v-if="!pdfSource && !$store.getters.isFormProcessing" :title="'Utleveringsseddel'" :message="'Trykk på Utlever for å generere utleveringsseddel'" :large="false" :icon="'button-glyph-contract'"/>
              <TheLoader :active="!pdfSource && $store.getters.isFormProcessing"/>
            </div>
          </div>
        </div>
      </div>

      <a v-if="!pdfSource" href="javascript:;" class="modal-close modal-window-close-button" @click="closeButtonClick()">
        <span>Lukk</span>
        <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg>
      </a>
    </overlay-scrollbars>
  </div>
</template>

<script>
import SignatureService from '@/services/SignatureService'

export default {
  name: 'SignedObjektModal',
  props: {
    kundenr: {
      type: Number,
      required: true
    },
    objektid: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      pdfSource: false
    }
  },
  created () {
    this.setFormProcessing(true)

    SignatureService.getPdf(this.kundenr, this.objektid)
      .then(response => {
        const url = process.env.VUE_APP_AVANTI_API_URL + response.data.file

        this.pdfSource = url
      })
      .catch(error => {
        console.log(error)
        this.$helpers.showErrorAlert('Feil', 'Kunne ikke opprette PDF')
      })
      .then(() => {
        this.setFormProcessing(false)
      })
  },
  methods: {
    closeButtonClick: function () {
      if (!this.$store.getters.isFormProcessing) {
        this.$emit('close')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/SignedObjektModal.vue